/* eslint-disable react/jsx-no-literals */
import React from 'react'

function FacebookMaintenaceIcon(props) {
  return (
    <svg
      id="Group_413"
      data-name="Group 413"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="75"
      height="75"
      viewBox="0 0 75 75"
      {...props}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_142"
            data-name="Rectangle 142"
            width="75"
            height="75"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_83" data-name="Group 83" clipPath="url(#clip-path)">
        <path
          id="Path_125"
          data-name="Path 125"
          d="M75.385,37.693A37.693,37.693,0,1,0,31.8,74.927V48.588H22.232v-10.9H31.8v-8.3c0-9.447,5.628-14.665,14.237-14.665a57.94,57.94,0,0,1,8.438.737v9.276H49.725c-4.682,0-6.142,2.905-6.142,5.886v7.071H54.036l-1.671,10.9H43.582V74.927a37.7,37.7,0,0,0,31.8-37.235"
          fill="#4676ed"
        />
        <path
          id="Path_126"
          data-name="Path 126"
          d="M69.947,60.232l1.671-10.9H61.164V42.265c0-2.981,1.46-5.886,6.142-5.886H72.06V27.1a57.941,57.941,0,0,0-8.438-.737c-8.61,0-14.237,5.218-14.237,14.665v8.3h-9.57v10.9h9.57V86.571a38.1,38.1,0,0,0,11.779,0V60.232Z"
          transform="translate(-17.582 -11.643)"
          fill="#fff"
        />
      </g>
    </svg>
  )
}

export default FacebookMaintenaceIcon
